import Oidc from 'oidc-client';
import { store } from '../store.js';
import axios from 'axios';
if (window._env_config.DEBUG) {
  Oidc.Log.logger = console;
  Oidc.Log.level = Oidc.Log.INFO;
}

const appUrl =
  window.location.protocol +
  '//' +
  window.location.hostname +
  (window.location.port ? ':' + window.location.port : '') +
  process.env.BASE_URL;

const config = {
  authority: '',
  client_id: 'c91674279338bd79139a1ee560c89cd38b358b4a0',
  redirect_uri: appUrl + 'callback',
  response_type: 'code',
  scope: 'tatral_filip openid tatral_filip_api',
  userStore: new Oidc.WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTime: 70,
  filterProtocolClaims: true,
  loadUserInfo: false,
  silent_redirect_uri: appUrl + 'static/auth-silent-renew-token.html',
};

class UserService {
  constructor() {
    this.userManager = null;
  }
  async init() {
   // await axios.get(window._env_config.AUTH_SERVER_URL + '/api/info/server-url').then(res => {
    //  if (res) {
        config.authority = window._env_config.AUTH_SERVER_URL.toLowerCase();

        this.userManager = new Oidc.UserManager(config);

        this.userManager.events.addUserLoaded(function (user) {
          if (user != null) {
            store.commit('auth/setUser', user);
          }
        });

        this.userManager.events.addAccessTokenExpiring(function () {
          store.dispatch('auth/signInSilent');
        });

        this.userManager.events.addUserSignedOut(function () {
          store.dispatch('auth/signOutLocalExpiredUserAndSignIn');
        });
        return this.userManager;
     // }
   // });
  }

  getUser() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(function (result) {
          if (result == null) {
            return resolve(null);
          } else {
            return resolve(result);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  signinSilent() {
    return new Promise((resolve, reject) => {
      this.userManager
        .signinSilent()
        .then(function (result) {
          if (result == null) {
            return resolve(null);
          } else {
            return resolve(result);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  signinRedirect(state) {
    this.userManager.signinRedirect(state).catch(function (err) {
      console.log(err);
    });
  }

  signoutRedirect() {
    return new Promise((resolve, reject) => {
      this.userManager
        .signoutRedirect()
        .then(function (result) {
          if (result == null) {
            return resolve(null);
          } else {
            return resolve(result);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  removeUser() {
    return new Promise((resolve, reject) => {
      this.userManager
        .removeUser()
        .then(function (result) {
          if (result == null) {
            return resolve(null);
          } else {
            return resolve(result);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  async signinRedirectCallback() {
    return this.userManager.signinRedirectCallback().catch(function (err) {
      console.log(err);
    });
  }
}

export default UserService;
